import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { Proforma } from "@/lib/proforma.api";
import type { ProformaStatusFilter, ProformaViewMode } from "../proforma.constants";

export function useProformasPageState() {
  const [viewMode, setViewMode] = useState<ProformaViewMode>("table");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState<ProformaStatusFilter>("all");
  const [selectedProforma, setSelectedProforma] = useState<Proforma | null>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  function resetFilters() {
    setSearch("");
    setStatusFilter("all");
  }

  return {
    viewMode,
    setViewMode,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    selectedProforma,
    setSelectedProforma,
    resetFilters,
  };
}
